import {
  FormControl,
  FormLabel,
  Input,
  Option,
  Select,
  Stack,
  Textarea,
} from "@mui/joy";
import type { GenerationBrief } from "../../hooks/useArticleGeneration";

export const BRIEF_PRESETS: Record<
  GenerationBrief["preset"],
  { label: string; facts: string; cta: string }
> = {
  guide: {
    label: "Homeowner guide",
    facts:
      "Explain the options, common questions, and practical next steps. Do not invent prices or credentials.",
    cta: "Invite the reader to request an inspection.",
  },
  storm: {
    label: "Storm damage",
    facts:
      "Describe visible warning signs and safe next steps. Avoid promises about insurance coverage.",
    cta: "Offer a professional storm-damage inspection.",
  },
  materials: {
    label: "Material comparison",
    facts:
      "Compare durability, maintenance, appearance, and suitability. Use only supplied product facts.",
    cta: "Invite the reader to discuss suitable materials.",
  },
  maintenance: {
    label: "Seasonal maintenance",
    facts:
      "Give a practical seasonal checklist. Leave roof access and repairs to qualified professionals.",
    cta: "Offer a maintenance assessment.",
  },
  custom: { label: "Custom brief", facts: "", cta: "" },
};
export const initialBrief: GenerationBrief = {
  preset: "guide",
  audience: "Local homeowners",
  tone: "Helpful and clear",
  facts: BRIEF_PRESETS.guide.facts,
  cta: BRIEF_PRESETS.guide.cta,
};
export function ContentBriefFields({
  value,
  onChange,
}: {
  value: GenerationBrief;
  onChange: (value: GenerationBrief) => void;
}) {
  return (
    <Stack spacing={1.5}>
      <FormControl>
        <FormLabel>Brief preset</FormLabel>
        <Select
          value={value.preset}
          onChange={(_, key) => {
            if (key)
              onChange({
                ...value,
                preset: key,
                facts: BRIEF_PRESETS[key].facts,
                cta: BRIEF_PRESETS[key].cta,
              });
          }}
        >
          {Object.entries(BRIEF_PRESETS).map(([key, preset]) => (
            <Option key={key} value={key}>
              {preset.label}
            </Option>
          ))}
        </Select>
      </FormControl>
      <FormControl>
        <FormLabel>Audience</FormLabel>
        <Input
          value={value.audience}
          onChange={(e) => onChange({ ...value, audience: e.target.value })}
          slotProps={{ input: { maxLength: 500 } }}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Tone</FormLabel>
        <Input
          value={value.tone}
          onChange={(e) => onChange({ ...value, tone: e.target.value })}
          slotProps={{ input: { maxLength: 200 } }}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Key facts and requirements</FormLabel>
        <Textarea
          minRows={3}
          value={value.facts}
          onChange={(e) => onChange({ ...value, facts: e.target.value })}
          slotProps={{ textarea: { maxLength: 5000 } }}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Call to action</FormLabel>
        <Input
          value={value.cta}
          onChange={(e) => onChange({ ...value, cta: e.target.value })}
          slotProps={{ input: { maxLength: 1000 } }}
        />
      </FormControl>
    </Stack>
  );
}
